import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { TopNav } from './components/TopNav';
import { SiteFooter } from './components/SiteFooter';
import { BoardPositioning } from './pages/BoardPositioning';
import { About } from './pages/About';
import { Experiences } from './pages/Experiences';
import { Skills } from './pages/Skills';
import { ImpactMetrics } from './pages/ImpactMetrics';
import { ValueProposition } from './pages/ValueProposition';
import { CareerRecord } from './pages/CareerRecord';
import { TechnicalMastery } from './pages/TechnicalMastery';
import { BoardEducation } from './pages/BoardEducation';
import { ContactPortal } from './pages/ContactPortal';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="23ujlkfp2jt53">
      <ScrollToTop data-id="element-1" data-mp="23v2uj6wqr76z" />
      <div className="flex min-h-full w-full flex-col bg-white font-sans" data-id="element-2" data-mp="3ijxpcqos80jw">
        <TopNav data-id="element-3" data-mp="3ijpdn24eb1aa" />
        <div className="flex-1" data-id="element-4" data-mp="3ii4qvyobommz">
          <Routes data-id="element-5" data-mp="3mkrdnl64zhdb">
            <Route path="/" element={<BoardPositioning data-id="element-7" data-mp="3mjq45l4rr2xp" />} data-id="element-6" data-mp="3mk85uxa7a9d0" />
            <Route path="/about" element={<About data-id="element-9" data-mp="3rdas0kcnegj6" />} data-id="element-8" data-mp="3rcj7q5oi4587" />
            <Route path="/experiences" element={<Experiences data-id="element-11" data-mp="5yhupa6n3cr" />} data-id="element-10" data-mp="3rd1bdndhtlq5" />
            <Route path="/skills" element={<Skills data-id="element-13" data-mp="5gbgztt38r4" />} data-id="element-12" data-mp="682dxcgkib2" />
            <Route path="/impact" element={<ImpactMetrics data-id="element-15" data-mp="2zlld2w2kqak3" />} data-id="element-14" data-mp="7stfczkdj46" />
            <Route path="/value-proposition" element={<ValueProposition data-id="element-17" data-mp="33mouvo46mgny" />} data-id="element-16" data-mp="2zmo557bmuj1l" />
            <Route path="/career" element={<CareerRecord data-id="element-19" data-mp="33mymfg4vkvvr" />} data-id="element-18" data-mp="33nq6btp41567" />
            <Route path="/technical" element={<TechnicalMastery data-id="element-21" data-mp="38li6fazwrxlh" />} data-id="element-20" data-mp="38lrq6gud18iq" />
            <Route path="/board-education" element={<BoardEducation data-id="element-23" data-mp="3dkl5met7j9lj" />} data-id="element-22" data-mp="38kgmeh0x00rm" />
            <Route path="/contact" element={<ContactPortal data-id="element-25" data-mp="3diruam7ng177" />} data-id="element-24" data-mp="3dlntedv8gvx8" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" data-mp="nuhged3fk1rn" />} data-id="element-26" data-mp="nvstj3irmlvf" />
          </Routes>
        </div>
        <SiteFooter data-id="element-28" data-mp="sudlkfnv5z8s" />
      </div>
    </BrowserRouter>;
}